/* eslint-disable @typescript-eslint/no-unused-vars */
import type { SessionId } from '../../domain/Session';
import { sessionByIdQuery } from '../../sessions/queries';
import { createCommand } from '../../utils';
import { moduleName, requestMapBounds } from '../state';

export const ZoomOnSessionCommand = createCommand(
    `${moduleName}/ZOOM_ON_SESSION`,
    async (sessionId: SessionId, { dispatch, getState }) => {
        const session = sessionByIdQuery(sessionId)(getState());

        if (session) {
            dispatch(requestMapBounds(session.bbox));
        }
    },
);
